import React from "react";
import SetupLimit from "./setupLimit";
import ProductLenderMapping from "./productLenderMapping";
import LenderRanking from "./lenderRanking";
import SelectDate from "./selectDate";

const DynamicStepComponent = (props) => {
  const components = {
    setupLimit: SetupLimit,
    productLenderMapping: ProductLenderMapping,
    lenderRanking: LenderRanking,
    selectDate: SelectDate,
  };

  const NewComponent = components[props.componentNameKey || ""];

  return NewComponent ? <NewComponent {...props} /> : null;
};

export default DynamicStepComponent;
